import {WorkspaceModelType} from "../stores/WorkspaceStore";
import {Item} from "../API";
import {LocalChangeHistory} from "./LocalChangeHistory";

import {debounce} from "../utils/debounce";
import {parseJsonOrFallback, parseOrFallback} from "../stores/convertors/parseJsonOrFallback";
import {itemToItemMSTSnapshotIn} from "../stores/convertors/itemToItemMSTSnapshotIn";


export const syncItemCreate = (workspaceMST: WorkspaceModelType, serverItem: Item) => {
    const itemMST = workspaceMST.items.get(serverItem.id);
    if (itemMST) {
        return;
    }
    workspaceMST.addItemSync(itemToItemMSTSnapshotIn(serverItem));
}

export const syncItemUpdate = (workspaceMST: WorkspaceModelType, serverItem: Item) => {
    const serverVersion = serverItem.version;

    const itemMST = workspaceMST.items.get(serverItem.id);
    if (!itemMST) {
        return;
    }
    if (itemMST.lastSyncedVersion !== serverVersion) {
        if (!getChangeHistoryForItem(itemMST.id).isChangeLocal(serverItem)) {

            const isEnteringStatusView = (
                (serverItem.trashed || serverItem.archived)
                && !itemMST.trashed
                && !itemMST.archived
            );
            if (isEnteringStatusView) {
                itemMST.setStatusSourceLibraryId(
                    serverItem.statusSourceLibraryId ?? workspaceMST.getStatusSourceLibraryIdForItem(itemMST.id)
                );
                itemMST.setStatusRestoreParentIds(
                    serverItem.statusRestoreParentIds
                        ? parseJsonOrFallback(serverItem.statusRestoreParentIds)
                        : itemMST.parentIds.toJSON()
                );
            } else if (!serverItem.trashed && !serverItem.archived) {
                itemMST.setStatusSourceLibraryId(null);
                itemMST.setStatusRestoreParentIds([]);
            } else {
                itemMST.setStatusSourceLibraryId(serverItem.statusSourceLibraryId ?? null);
                itemMST.setStatusRestoreParentIds(parseJsonOrFallback(serverItem.statusRestoreParentIds || '[]'));
            }

            if (!itemMST.isRenaming) {
                itemMST.setName(serverItem.name!);
            }
            itemMST.setDescription(serverItem.description ?? '');
            itemMST.setUpdatedAt(serverItem.updatedAt);
            itemMST.setUpdatedBy(serverItem.updatedBy ?? null);
            itemMST.setChildIds(parseJsonOrFallback(serverItem.childIds));
            itemMST.setParentIds(parseJsonOrFallback(serverItem.parentIds));
            itemMST.setTrashed(serverItem.trashed);
            itemMST.setArchived(serverItem.archived);

            itemMST.setAcknowledgementRequired(!!serverItem.acknowledgementRequired);
            itemMST.setAcknowledgement(parseOrFallback(serverItem.acknowledgement, {}));

            itemMST.setSyncedVersion(serverVersion);
        } else {
            removeStepDebounce(itemMST.id, serverItem.updatedAt!);
        }
    }
}

export const syncItemDelete = (workspaceMST: WorkspaceModelType, serverItem: Item) => {
    const serverVersion = serverItem.version;

    const itemMST = workspaceMST.items.get(serverItem.id);
    if (!itemMST) {
        return;
    }
    if (itemMST.lastSyncedVersion !== serverVersion) {
        if (!getChangeHistoryForItem(itemMST.id).isChangeLocal(serverItem)) {
            workspaceMST.removeItemSync(serverItem.id);
        } else {
            removeStepDebounce(itemMST.id, serverItem.updatedAt!);
        }
    }
}

export const itemChangeHistoryMap = new Map<string, LocalChangeHistory>();

export const getChangeHistoryForItem = (itemId: string) => {
    if (!itemChangeHistoryMap.has(itemId)) {
        itemChangeHistoryMap.set(itemId, new LocalChangeHistory());
    }
    return itemChangeHistoryMap.get(itemId)!;
}

const removeStepDebounce = debounce(
    (itemId: string, step: string) => {
        getChangeHistoryForItem(itemId).removeStep(step);
    },
    2000
)
